const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '严格的内容审核机制，所有资源经过安全检测，保障用户信息安全与隐私。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新及时',
    description: '专业编辑团队全天候跟踪行业动态，第一时间为您带来最新内容和资源。',
  },
  {
    icon: 'ri-stack-line',
    title: '资源丰富',
    description: '覆盖软件、教程、影视、游戏等六大领域，满足您的多元需求。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '以用户体验为核心，持续优化平台功能，提供贴心服务与支持。',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">为什么选择91网</h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            我们致力于为用户提供最优质的综合服务体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors duration-300 group cursor-default"
            >
              <div className="w-11 h-11 rounded-md bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}